import React from "react";
import { currentTenant } from "../../tenants";

export const PrivacyPolicyPage: React.FC = () => {
  const TenantPrivacyPolicyPage = currentTenant.pages.PrivacyPolicyPage;

  return <TenantPrivacyPolicyPage />;
};
